<template>
  <div class="min-h-screen">
    <div class="flex items-center justify-center h-16 py-2 bg-dark-type-1">
      <router-link to="/">
        <img src="@/assets/img/logo.png" style="width: 160px" alt="Shuttlers" />
      </router-link>
    </div>
    <div class="flex flex-col items-center justify-center min-h-screen">
      <div class="w-full max-w-lg">
        <register @close="showRegisterModal = false"></register>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";

export default {
  components: {
    Register
  },
  data() {
    return {};
  },
};
</script>